// documentBody :: IOSync Node
export function documentBody() {
  return document.body;
}
